import css from './header.module.scss';
import {HeaderProps} from './header.types';

export const Header = (props: HeaderProps): JSX.Element => {
	return (
		<div className={css.container}>
			<div className={css.arrow} onClick={props.onBack}>
				<img src="img/arrowLeftBlue.svg" />
			</div>
			<div className={css.title}>{props.title}</div>
		</div>
	);
};
